import React from "react";
import { FiltersTypes } from "@common/types/filters/general";

interface Props {
    filters: FiltersTypes;
}

export const DueDateFilterLabel: React.FC<Props> = ({ filters }) => {
    const { overdue, minDue, maxDue } = filters;

    if (overdue === undefined && minDue === undefined && maxDue === undefined) {
        return null;
    }

    // Format the range label based on min and max values
    const getRangeLabel = () => {
        if (minDue === undefined && maxDue === undefined) {
            return "";
        }

        if (minDue !== undefined && maxDue !== undefined) {
            return `${minDue}-${maxDue}d`;
        }

        if (minDue !== undefined) {
            return `${minDue}d+`;
        }

        if (maxDue !== undefined) {
            return `0-${maxDue}d`;
        }

        return "";
    };

    const rangeLabel = getRangeLabel();
    const statusLabel = overdue ? "Overdue" : "Not yet due";

    return (
        <span>
            {rangeLabel && <span>{rangeLabel} </span>}
            {statusLabel}
        </span>
    );
};
